module.exports = __webpack_public_path__ + "static/media/mario-bg.350225af.svg";